import { render, staticRenderFns } from "./PreviewImageOverlay.vue?vue&type=template&id=265f6f5c&scoped=true"
import script from "./PreviewImageOverlay.vue?vue&type=script&lang=js"
export * from "./PreviewImageOverlay.vue?vue&type=script&lang=js"
import style0 from "./PreviewImageOverlay.vue?vue&type=style&index=0&id=265f6f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265f6f5c",
  null
  
)

export default component.exports